import { ArticleEntity, EditArticle, EditArticleAppProps } from "../editArticle/editArticle"
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { Sheet, SheetEventType } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { NotificationHelper } from "../core/util/notificationHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { FieldInstance } from "../core/components/field";
import { Dialog, DialogProps } from "../core/components/dialog";
import { Config } from "../core/config/config";
import { ComponentHelper } from "../core/util/componentHelper";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { AssemblyGroupViewElement, getFilteredGridData, setOptions } from "../baugruppen/assemblyGroupViewElements";
import { OpenEditArticleDialog } from "../editArticle/editArticleDialog";
import { ResourcePlanningAppProps } from "./resourcePlanning";
import { GridArticle } from "../tasks/workPackage/workPackage";
import { Article } from "../commonInterfaces";
import { openStockSearch } from "../stock/openStockSearch";
import React from "react";
export default class MaterialGrid extends React.Component<ResourcePlanningAppMaterialGridProps, ResourcePlanningAppMaterialGridState>{
    private gridData = [];
    private gridOptions: kendo.ui.GridOptions;
    private dataUrl: string;
    private enableButton: boolean;
    private enableUnpacked: boolean;
    private gridRef: Grid = null;
    private gridWrapperElementRef = null;
    private factory = ComponentHelper.createFactory();
    private topMostSheet: Sheet = null;
    private warehouseActive = Config.settings.warehouseActive;
    private UNPACK_BTN_ID = "unpack";
    private SUMMARIZE_BTN_ID = "summarize"
    private WAREHOUSE_BTN_ID: string = "warehouse";

    private FONT_COLOR: "#333"
    private PROJECT_BACKGROUND_COLOR = "#e0e0e0";
    private WAREHOUSE_BACKGROUND_COLOR = "#b2dfdb";

    private dialogProps: DialogProps = {
        title: "",
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.onOk()
                }
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 400

    };
    

    constructor(props) {
        super(props);
        this.enableButton = true;
        this.enableUnpacked = false;
        this.setEvents();
        let showProjectMaterial = this.showProjectMaterial(props);

        this.dataUrl = "ResourcePlanningArticle/GetGridData?projnr=" + encodeURIComponent(this.props.entity.ProjNr) + '&pindex=' + encodeURIComponent(this.props.entity.PIndex.toString()) + "&showProjectMaterial=" + showProjectMaterial;
        this.dialogProps.title = Helper.getTranslation("Einsatz.MaterialRegistration");

        const aP: ArticlePlanning = {
            projNr: this.props.entity.ProjNr,
            pIndex: this.props.entity.PIndex,
            artNr: null,
            menge: 0,
            pos: null
        };
        this.state = {
            dialogOpen: false,
            maxAmount: 0,
            articlePlanning: aP,
            unit: "",
            gridData: [],
            summarized: false,
            onlyParents: false,
            materialCustomButtonSettings: {
                summarize: true,
                unpack: true
            },
            deleteButton: true,
            editButton: true,
            showCopyDialog: false
        };

        this.setOptions(this.state.summarized, this.state.onlyParents);
    }

    private onOk = async () => {
        if (this.state.articlePlanning.menge > 0) {
            await HTTPService.post("ResourcePlanningArticle/PlanArticles", this.state.articlePlanning);
            let newAP = this.state.articlePlanning;
            newAP.menge = 0;
            await this.getGridData();
            this.setState({ articlePlanning: newAP, dialogOpen: false })
        }
    }

    private showProjectMaterial(props: any) {
        let showProjectMaterial = true;
        if (Object.keys(props).indexOf('showProjectMaterial') > -1) {
            showProjectMaterial = props.showProjectMaterial;
        }
        return showProjectMaterial;
    }

    private setOptions(summarized: boolean, onlyParents: boolean) {
        this.gridOptions = setOptions(summarized, onlyParents, this.props.context.materialGrid);
        let showProjectMaterial = this.showProjectMaterial(this.props);
        if (showProjectMaterial) {
            this.gridOptions.columns.unshift(
                {
                    template: '#if(PIndex == null){#<div class="grid-button-custom" title="' + Helper.getTranslation("Einsatz.AllocateMaterial") + '"><i class="k-icon k-i-plus" aria-hidden="true"></i></div>#}#',
                    width: 32,
                    attributes: {
                        style: "overflow:visible",
                        "class": "grid-button-wrapper"
                    },
                    field: "rowoptions",
                    title: " ",
                }
            );
        }
    }

    private getGridData = () => {
        return new Promise<void>(async resolve => {
            const result = await HTTPService.get(this.dataUrl);
            this.gridData = result.Data.GridData;
            this.setOptions(this.state.summarized, this.state.onlyParents);
            let filteredGridData: ResourcePlanningArticleViewModel[] = getFilteredGridData(this.state.summarized, this.state.onlyParents, this.gridData);

            this.setState({ gridData: filteredGridData }, resolve);
        });
    }

    private openEditWindow = async (dataItem) => {
        const sheetTitle = Helper.getTranslation("Einsatz.ArtikelZumEinsatz");
        const contextType = "resourcePlanningArticleEdit";
        const [result, metaData] = await Promise.all([
            HTTPService.get<JsonResultClass<ArticleEntity>>('ResourcePlanningArticle/Init?projNr=' + encodeURIComponent(this.props.entity.ProjNr) + '&pindex=' + encodeURIComponent(this.props.entity.PIndex.toString()) + (Helper.hasValue(dataItem) ? "&pos=" + dataItem.Pos : "")),
            Helper.getMetaData("resourcePlanningArticle")
        ]);

        if (result.Code === 0) {
            const article = result.Data;
            article.Adrnr = this.props.entity.AdrNr;

            const sheet = General.Sheet.Manager.createSheet();
            sheet.setTitle(sheetTitle);
            sheet.bind(SheetEventType.SavedSuccessfully, () => {
                this.getGridData();
                        this.triggerRefreshSendState();
            });

            const articleEditProps: EditArticleAppProps = {
                entity: article,
                metadata: metaData,
                context: {
                    key1: "entity.ProjNr", keyVal1: this.props.entity.ProjNr,
                    key2: "entity.PIndex", keyVal2: this.props.entity.PIndex,
                    key3: "entity.Pos", keyVal3: ((this.props.entity) as any).Pos,
                    contextType: contextType
                },
                dataSources: {},
                isWindow: true,
                title: "",
                saveUrl: "ResourcePlanningArticle/SaveArticle"
            }

            sheet.show(() => {
                sheet.mountContent(EditArticle, articleEditProps);
            });
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }
    private openStockSearch = async () => {
        const articles = await openStockSearch();
        if (articles.length == 0)
            return;
        const lst: ResourcePlanningArticleViewModel[] = articles.map((dataItem) => {
            return {
                Datum: new Date(),
                IsNew: true,
                IsWatchable: false,
                IsWatched: false,
                RecordRight: {
                    CanRead: true,
                    CanWrite: true
                },
                Anzahl: dataItem.amount,
                Artikelnr: dataItem.artNr,
                Artikelnummer: dataItem.article.articlenumber,
                Id: kendo.guid(),
                Produkt: dataItem.article.product,
                Chargennr: dataItem.chargenNr,
                Seriennr: dataItem.serienNr,
                EkPreis: dataItem.article.ekpreis,
                Epreis: dataItem.article.preis,
                Gpreis: dataItem.article.preis * dataItem.amount,
                Kosten: dataItem.article.ekpreis * dataItem.amount,
                Rabatt: 0,
                Bezeichnung: dataItem.article.article,
                IsUnpacked: false,
                CanBeUnpacked: false,
                Summarized: false,
                Lagerid: dataItem.lagerId,
                Lagerplatzid: dataItem.lagerplatzId,
                Projnr: this.props.entity.ProjNr,
                PIndex: this.props.entity.PIndex
            };
        });
        await this.update(lst);
    }

    private create = () => {
        const sheet = General.Sheet.Manager.createSheetWithUrl("DynamicSearch/Window/Article?multi=true&displayPattern=[[bezeichnung]]", { disableTabTitle: true }, null, true);
        sheet.setTitle(Helper.getTranslation("Einsatz.ArtikelZumEinsatz"));
        sheet.bind(SheetEventType.ItemsSelected, async (e: { data: Array<Article> }) => {
            if (Array.isArray(e.data)) {
                let vm = await OpenEditArticleDialog();

                let vorgangArtikelViewModelLst: ResourcePlanningArticleViewModel[] = [];
                for (let i = 0; i < e.data.length; i++) {
                    let vorgangArtikel = Helper.createEmptyEntity() as ResourcePlanningArticleViewModel;
                    vorgangArtikel.Artikelnummer = e.data[i].artikelnummer;
                    vorgangArtikel.Artikelnr = e.data[i].artnr;
                    vorgangArtikel.Anzahl = vm.Anzahl;
                    vorgangArtikel.Datum = new Date();
                    vorgangArtikel.Produkt = e.data[i].produkt;
                    vorgangArtikel.Chargennr = e.data[i].chargennr;
                    vorgangArtikel.Seriennr = e.data[i].seriennr;
                    vorgangArtikel.EkPreis = e.data[i].ekpreis;
                    vorgangArtikel.Epreis = e.data[i].preis;
                    vorgangArtikel.Gpreis = e.data[i].preis * vm.Anzahl;
                    vorgangArtikel.Kosten = e.data[i].ekpreis * vm.Anzahl;
                    vorgangArtikel.Bezeichnung = e.data[i].bezeichnung;
                    vorgangArtikel.Rabatt = 0;
                    vorgangArtikel.Projnr = this.props.entity.ProjNr;
                    vorgangArtikel.PIndex = this.props.entity.PIndex;
                    vorgangArtikel.IsUnpacked = false;
                    vorgangArtikel.CanBeUnpacked = e.data[i].isassemblygroup;
                    vorgangArtikel.Summarized = false;
                    vorgangArtikel.Maschnr = vm.Maschnr;
                    vorgangArtikelViewModelLst.push(vorgangArtikel);
                }

                await this.update(vorgangArtikelViewModelLst);
            }
        });
    }

    private update = async (data: ResourcePlanningArticleViewModel[]) => {
        const result = await HTTPService.post<JsonResultClass>("ResourcePlanningArticle/SaveArticles", data);
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(result.Message);
            await this.getGridData();
                    this.triggerRefreshSendState();
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private triggerRefreshSendState = () => {
        this.topMostSheet.trigger(SheetEventType.Custom, { command: "refreshSendState" });
    }

    private remove = async (dataItem) => {
        const isOK = await DialogHelper.confirm(this.props.translations["Standard.Msg.Loeschen"]);
        if (isOK) {
            const url = 'ResourcePlanningArticle/Delete?projNr=' + encodeURIComponent(this.props.entity.ProjNr) + '&pindex=' + encodeURIComponent(this.props.entity.PIndex.toString()) + '&pos=' + dataItem.Pos;
            const result = await HTTPService.post(url);
                        if (result.Code == 0) {
                await this.getGridData();
                            this.triggerRefreshSendState();
                        }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private setFullHeightRef = (ref: HTMLDivElement) => {
        this.gridWrapperElementRef = ref;
    }

    private setGridRef = (ref: Grid) => {
        this.gridRef = ref;
    }

    private renderDialog = () => {
        let text: string = Helper.getTranslation("Einsatz.AvailableAmount");
        let newText = text.replace("{Unit}", this.state.unit);
        const labelUp: string = newText;
        text = Helper.getTranslation("Einsatz.SelectedAmount");
        newText = text.replace("{Unit}", this.state.unit);
        const labelDown: string = newText;

        return (
            <div>
                <Dialog {...this.dialogProps} open={this.state.dialogOpen}>
                    {
                        this.state.dialogOpen ?
                            <div>
                                <FieldInstance label={labelUp} noHover={true} labelStyle={{ width: "225px" }}>
                                    {this.renderLabel()}
                                </FieldInstance>
                                <FieldInstance label={labelDown} noHover={true} labelStyle={{ width: "225px" }}>
                                    <IsNumericTextBox {...this.renderNumericTextBoxProps()} />
                                </FieldInstance>
                            </div>
                            : null
                    }
                </Dialog>
            </div>
        );
    }

    private renderLabel = () => {
        let style: React.CSSProperties = {
            display: "flex",
            margin: "9px"
        };
        const labelText = this.state.maxAmount.toString();
        return (
            <div style={style}>
                {labelText}
            </div>
        );
    }

    private renderNumericTextBoxProps = () => {
        let props = this.factory.getDefaultNumericTextBoxProps();
        props.field.max = this.state.maxAmount;
        props.field.min = 0;
        props.value = this.state.articlePlanning.menge;
        props.field.format = "#.00";
        props.onChange = this.handleNumericTextBoxChange;
        return props;
    }

    private handleNumericTextBoxChange = (_, value: any) => {
        let newAp = this.state.articlePlanning;
        newAp.menge = value;
        this.setState({ articlePlanning: newAp });
    }

    private handleDataBound = (e) => {
        var data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            const dataItem: ResourcePlanningArticleViewModel = data[i];
            const row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
            if (data[i].PIndex == null) {
                $(row).css("background-color", this.PROJECT_BACKGROUND_COLOR);
                $(row).css("color", this.FONT_COLOR);
            } else if (this.warehouseActive && (Helper.hasValue(dataItem.Lagerid) && dataItem.Lagerid > 0) && (Helper.hasValue(dataItem.Lagerplatzid) && dataItem.Lagerplatzid > 0)) {
                $(row).css("background-color", this.WAREHOUSE_BACKGROUND_COLOR);
                $(row).css("color", this.FONT_COLOR);
            }
        }
    }

    private onSelectionChanged = (dataItem: any) => {
        if (dataItem != null) {
            let canBeUnpacked = dataItem.CanBeUnpacked;
            this.enableUnpacked = Helper.hasValue(canBeUnpacked) ? canBeUnpacked : false;
            if (dataItem["PIndex"] == null) {
                this.enableButton = false;
            } else {
                this.enableButton = true;
            }
            const enableButtons = !dataItem.Summarized && !dataItem.IsUnpacked;
            let newSettings = {
                summarize: !Helper.hasValue(dataItem.ResolvedFrom),
                unpack: this.state.materialCustomButtonSettings.unpack
            };

            this.setState({
                editButton: enableButtons,
                deleteButton: enableButtons,
                materialCustomButtonSettings: newSettings
            });
        }
    }

    private handleClickStandardButton = async (type: ToolBarStandardButtonType, dataItem: any) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this.create();
                break;
            case ToolBarStandardButtonType.EDIT:
                await this.openEditWindow(dataItem);
                break;
            case ToolBarStandardButtonType.DELETE:
                await this.remove(dataItem);
                break;
        }
    }

    private setEvents = () => {
        $(window).on("projectArticlesAreChanged", async (e, d) => {
            if (d.update) {
                await this.getGridData()
                this.setState({});
            }

        });
    }

    componentDidMount() {
        $(this.gridWrapperElementRef).on("mouseup", ".grid-button-custom", (e) => {
            if (this.props.entity.RecordRight.CanWrite) {
                let tr = $(e.target).closest("tr");
                let data = this.gridRef.getDataItem(tr[0]);
                let newAP: ArticlePlanning = this.state.articlePlanning;
                newAP.artNr = data["Artikelnr"];
                newAP.pos = data["Pos"];
                newAP.menge = data["Anzahl"];
                this.setState({ dialogOpen: true, maxAmount: data["Anzahl"], articlePlanning: newAP, unit: data["Einheit"] });
            }
        });

        this.topMostSheet = General.Sheet.Manager.getTopMostSheet();

        this.getGridData();
    }

    private handleCustomButtonClick = async (id: string, dataItem: ResourcePlanningArticleViewModel) => {
        switch (id) {
            case this.UNPACK_BTN_ID:
                await this.unpack(dataItem);
                break;
            case this.SUMMARIZE_BTN_ID:
                await this.summarize()
                break;
            case this.WAREHOUSE_BTN_ID:
                await this.openStockSearch();
                break;
        }       
    }

    private unpack = async (dataItem: ResourcePlanningArticleViewModel) => {
        // Kopf raus, Kinder rein
        let result = await HTTPService.post<JsonResultClass<boolean>>("ResourcePlanningArticle/UnpackAssemblyGroupPart", dataItem);
        if (result.Code === 0) {
            this.getGridData();
                this.triggerRefreshSendState();
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private summarize = async () => {
        let result = await HTTPService.post<JsonResultClass<boolean>>("ResourcePlanningArticle/SummarizeArticles", { projNr: this.props.entity.ProjNr, pindex: this.props.entity.PIndex });
        if (result.Code === 0) {
            this.getGridData();
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private changeOptions = (newSummarized, newOnlyParents) => {
        let customButtonSettings = {
            summarize: !newSummarized,
            unpack: !newSummarized
        };;
        this.setOptions(newSummarized, newOnlyParents);

        let copyData = this.gridData.filter(a => Helper.hasValue(a.PIndex));
        let dataNotToFilter = this.gridData.filter(a => !Helper.hasValue(a.PIndex));

        let gridData = getFilteredGridData(newSummarized, newOnlyParents, copyData);

        dataNotToFilter.forEach(a => gridData.push(a));

        this.setState({
            onlyParents: newOnlyParents,
            summarized: newSummarized,
            materialCustomButtonSettings: customButtonSettings,
            gridData: gridData
        });
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("Standard.Neu"), enabled: this.props.entity.RecordRight.CanWrite },
            { type: ToolBarStandardButtonType.EDIT, caption: Helper.getTranslation("Standard.Editieren"), enabled: (this.props.entity.RecordRight.CanWrite && this.enableButton && this.state.editButton) },
            { type: ToolBarStandardButtonType.DELETE, caption: Helper.getTranslation("Standard.Loeschen"), enabled: (this.props.entity.RecordRight.CanWrite && this.enableButton && this.state.deleteButton) }
        ];

        const warehouseBTN = this.warehouseActive ? { autoEnabledOnRecordSelected: false, caption: Helper.getTranslation("WebSMS.Warehouse"), enabled: (this.props.entity.RecordRight.CanWrite), iconClass: "fa-regular fa-warehouse", id: this.WAREHOUSE_BTN_ID } : null;

        const customButtons: Array<GridCustomToolBarButton> = [
            warehouseBTN,
            { autoEnabledOnRecordSelected: true, caption: Helper.getTranslation("Einsatz.Unpack"), enabled: (this.props.entity.RecordRight.CanWrite && this.enableButton) && this.enableUnpacked && this.state.materialCustomButtonSettings.unpack, iconClass: "k-i-redo", id: this.UNPACK_BTN_ID },
        ].filter(btn => Helper.hasValue(btn));

        // Erstmal ausblenden da es sowieso kaum Anwendung finden könnte
        //customButtons.push({ autoEnabledOnRecordSelected: true, caption: this._translations["Einsatz.SummarizeParts"], enabled: this.props.entity.RecordRight.CanWrite && this.state.materialCustomButtonSettings.summarize, iconClass: "k-i-redo", id: "summarize" });
        const content = (<Grid
            data={this.state.gridData}
            options={this.gridOptions}
            id="resourcePlanningMaterial"
            onDataBound={this.handleDataBound}
            ref={this.setGridRef}
            standardButtons={standardButtons}
            customButtons={customButtons}
            onClickStandardButton={this.handleClickStandardButton}
            onClickCustomButton={this.handleCustomButtonClick}
            onSelectionChanged={this.onSelectionChanged} />
        )

        return (
            <FullHeightContainer onRef={this.setFullHeightRef}>
                <AssemblyGroupViewElement changeOptions={this.changeOptions} onlyParents={this.state.onlyParents} summarized={this.state.summarized} />
                {content}
                {this.state.dialogOpen ? this.renderDialog() : null}
            </FullHeightContainer>
        );
    }
}

interface ResourcePlanningAppMaterialGridState extends AppMaterialState {
    dialogOpen: boolean;
    maxAmount: number;
    unit: string;
    articlePlanning: ArticlePlanning;
}

interface ArticlePlanning {
    projNr: string;
    pIndex: number;
    pos: number;
    artNr: number;
    menge: number;

}

interface ResourcePlanningArticleViewModel extends GridArticle {
    Projnr: string,
    PIndex?: number;
}

interface ResourcePlanningAppMaterialGridProps extends ResourcePlanningAppProps {
    translations: Array<string>;
}

export interface AppMaterialState {
    summarized: boolean;
    onlyParents: boolean;
    materialCustomButtonSettings: {
        unpack: boolean,
        summarize: boolean;
    };
    editButton: boolean;
    deleteButton: boolean;
    gridData: GridArticle[];
    showCopyDialog: boolean;
    machines?: { MachineNumber: string, Maschbezeichnung: string }[];
    selectedArticles?: number[];
}